<template>
    <div :class="daysClass">
        <button
            v-for="index in [0, 1, 2, 3, 4, 5, 6]"
            :key="index"
            :class="dayClass(index)"
            :disabled="isDayDisabled(index)"
            type="button"
            @click="emitEvent({ name: 'click', payload: index })"
        >
            {{ dayLabel(index) }}
        </button>
    </div>
</template>

<script>
    import dayjs from 'dayjs'

    export default {
        props: {
            currentDay: { type: Number, default: undefined },
            filledDays: { type: Array, default: () => [] },
            disabledDays: { type: Array, default: () => [] },
            isHidden: { type: Boolean, default: false },
        },

        computed: {
            daysClass() {
                return {
                    'schedule-days': true,
                    'schedule-days--is-hidden': this.isHidden,
                }
            },
        },

        methods: {
            isDayDisabled(index) {
                return this.disabledDays.includes(index)
            },

            dayClass(index) {
                return {
                    'schedule-days__day': true,
                    'schedule-days__day--current': this.currentDay === index,
                    'schedule-days__day--filled': this.filledDays.includes(index),
                    'schedule-days__day--disabled': this.isDayDisabled(index),
                }
            },

            dayLabel(index) {
                return dayjs()
                    .day(index + 1)
                    .format('ddd')
            },
        },
    }
</script>
